export enum AnnouncementType {
	GLOBAL = "GLOBAL",
	COMMAND = "COMMAND",
	NAV = "NAV",
}

export enum AnnouncementStyle {
	INFO = "INFO",
	ERROR = "ERROR",
}

export type Announcement = {
	id?: number;
	createdAt?: Date;
	updatedAt?: Date;
	title: string;
	content: string;
	type: AnnouncementType;
	style: AnnouncementStyle;
	published: boolean;
};
